import { gql } from '@apollo/client';

export const DELETE_LICENSE_MUTATION = gql`
	mutation RemoveLicense($id: Int!) {
		removeLicense(id: $id) {
      id
		}
	}
`;